import React, {Suspense} from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import RootComponent from './RootComponent'
import { persistor, store } from './store/reducers/store'
import { CssBaseline, ThemeProvider } from '@mui/material';
import e365theme from './styles/theme'



const App: React.FC = () => {
    return (
        <Suspense fallback={"loading..."}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ThemeProvider theme={e365theme}>
                        <CssBaseline />
                        <RootComponent />
                    </ThemeProvider>
                </PersistGate>
            </Provider>
        </Suspense>
    )
}

export default App
